module.exports = __webpack_public_path__ + "img/kantine_5_a.22ea92c2.jpg";